import { FunctionComponent } from 'react';
import Spinner from 'components/UI/V3/Spinner';
import RateRulesIsEmpty from './List/RateRulesIsEmpty';
import RateRulesContent from './List/RateRulesContent';
import RateRuleForm from './Form/RateRuleForm';
import { BoardingRateRulesProvider, useBoardingRateRules } from './BoardingRateRulesProvider';
import styles from './BoardingRateRules.module.scss';

const BoardingRateRulesInner: FunctionComponent = () => {
    const { isPageLoading, isTrueEmpty, showForm, selectedRateRule, openAddForm, closeForm } = useBoardingRateRules();

    if (isPageLoading) {
        return (
            <div className={styles.loadingContainer}>
                <Spinner />
            </div>
        );
    }

    return (
        <>
            {isTrueEmpty ? <RateRulesIsEmpty onClick={openAddForm} /> : <RateRulesContent />}
            {showForm && (
                <RateRuleForm
                    onClose={closeForm}
                    rateRule={selectedRateRule ?? undefined}
                />
            )}
        </>
    );
};

const BoardingRateRules: FunctionComponent = () => {
    return (
        <BoardingRateRulesProvider>
            <div className={styles.container}>
                <BoardingRateRulesInner />
            </div>
        </BoardingRateRulesProvider>
    );
};

export default BoardingRateRules;
